// Türkiye'den örnek GIS verileri
// İstanbul'daki 30 farklı park noktası
export const istanbulParkPoints = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "Emirgan Korusu",
        "area": 47.2,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0500, 41.1167]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Yıldız Parkı",
        "area": 15.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0167, 41.0500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Gülhane Parkı",
        "area": 12.3,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.9833, 41.0167]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Çamlıca Tepesi",
        "area": 8.5,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0833, 41.0167]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Fenerbahçe Parkı",
        "area": 6.2,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0167, 40.9667]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Maçka Parkı",
        "area": 4.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0000, 41.0500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Bebek Parkı",
        "area": 3.2,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0333, 41.0833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Ortaköy Parkı",
        "area": 2.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0167, 41.0500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Arnavutköy Parkı",
        "area": 5.1,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0500, 41.1000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kuruçeşme Parkı",
        "area": 3.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0333, 41.0667]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Etiler Parkı",
        "area": 4.2,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0167, 41.0833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Levent Parkı",
        "area": 3.5,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0000, 41.0833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Mecidiyeköy Parkı",
        "area": 2.9,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.9833, 41.0667]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Şişli Parkı",
        "area": 4.1,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.9667, 41.0500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Beşiktaş Parkı",
        "area": 3.7,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0000, 41.0500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kadıköy Parkı",
        "area": 5.3,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0167, 40.9833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Üsküdar Parkı",
        "area": 4.6,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0167, 41.0167]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Beykoz Parkı",
        "area": 6.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0833, 41.1333]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Sarıyer Parkı",
        "area": 7.2,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.0500, 41.1500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Beyoğlu Parkı",
        "area": 3.4,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.9833, 41.0333]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Maltepe Parkı",
        "area": 8.9,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.1500, 40.9167]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kartal Parkı",
        "area": 6.2,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.1833, 40.8833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Pendik Parkı",
        "area": 9.1,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.2167, 40.8667]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Tuzla Parkı",
        "area": 5.7,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.2500, 40.8500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Çekmeköy Parkı",
        "area": 7.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.1167, 41.0333]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Sancaktepe Parkı",
        "area": 6.5,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.1333, 40.9833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Sultanbeyli Parkı",
        "area": 4.3,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [29.1667, 40.9500]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Sultangazi Parkı",
        "area": 5.9,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.8667, 41.1000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Esenler Parkı",
        "area": 3.8,
        "type": "park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [28.9167, 41.0500]
      }
    }
  ]
};

// İstanbul park alanları - 20 noktalı çeşitli şekillerde polygonlar (küçük versiyon)
export const istanbulParkPolygon = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "5gen Park (Pentagon)",
        "total_area": 25.2,
        "type": "park",
        "shape": "pentagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.0000, 41.0000],
          [29.0100, 40.9950],
          [29.0150, 41.0000],
          [29.0100, 41.0050],
          [29.0000, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "6gen Park (Hexagon)",
        "total_area": 18.7,
        "type": "park",
        "shape": "hexagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.0200, 41.0000],
          [29.0250, 40.9980],
          [29.0300, 41.0000],
          [29.0300, 41.0020],
          [29.0250, 41.0040],
          [29.0200, 41.0020],
          [29.0200, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "7gen Park (Heptagon)",
        "total_area": 22.3,
        "type": "park",
        "shape": "heptagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.0400, 41.0000],
          [29.0420, 40.9980],
          [29.0440, 40.9990],
          [29.0460, 41.0010],
          [29.0450, 41.0030],
          [29.0430, 41.0040],
          [29.0410, 41.0020],
          [29.0400, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "8gen Park (Octagon)",
        "total_area": 30.1,
        "type": "park",
        "shape": "octagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.0600, 41.0000],
          [29.0620, 40.9980],
          [29.0640, 40.9990],
          [29.0660, 41.0010],
          [29.0660, 41.0030],
          [29.0640, 41.0040],
          [29.0620, 41.0030],
          [29.0600, 41.0010],
          [29.0600, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "9gen Park (Nonagon)",
        "total_area": 35.8,
        "type": "park",
        "shape": "nonagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.0800, 41.0000],
          [29.0815, 40.9985],
          [29.0830, 40.9990],
          [29.0845, 41.0005],
          [29.0850, 41.0020],
          [29.0840, 41.0035],
          [29.0825, 41.0045],
          [29.0810, 41.0035],
          [29.0800, 41.0020],
          [29.0800, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "10gen Park (Decagon)",
        "total_area": 28.4,
        "type": "park",
        "shape": "decagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.1000, 41.0000],
          [29.1015, 40.9985],
          [29.1030, 40.9990],
          [29.1045, 41.0005],
          [29.1050, 41.0020],
          [29.1045, 41.0035],
          [29.1030, 41.0045],
          [29.1015, 41.0040],
          [29.1000, 41.0025],
          [29.0985, 41.0010],
          [29.1000, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "12gen Park (Dodecagon)",
        "total_area": 42.6,
        "type": "park",
        "shape": "dodecagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.1200, 41.0000],
          [29.1210, 40.9990],
          [29.1220, 40.9995],
          [29.1230, 41.0005],
          [29.1235, 41.0015],
          [29.1230, 41.0025],
          [29.1220, 41.0030],
          [29.1210, 41.0025],
          [29.1200, 41.0015],
          [29.1190, 41.0005],
          [29.1185, 40.9995],
          [29.1190, 40.9990],
          [29.1200, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "15gen Park (Pentadecagon)",
        "total_area": 38.9,
        "type": "park",
        "shape": "pentadecagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.1400, 41.0000],
          [29.1407, 40.9993],
          [29.1414, 40.9997],
          [29.1421, 41.0007],
          [29.1424, 41.0017],
          [29.1421, 41.0027],
          [29.1414, 41.0033],
          [29.1407, 41.0029],
          [29.1400, 41.0019],
          [29.1393, 41.0009],
          [29.1390, 40.9999],
          [29.1393, 40.9989],
          [29.1400, 40.9983],
          [29.1407, 40.9987],
          [29.1400, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "18gen Park (Octadecagon)",
        "total_area": 45.2,
        "type": "park",
        "shape": "octadecagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.1600, 41.0000],
          [29.1606, 40.9994],
          [29.1612, 40.9997],
          [29.1618, 41.0006],
          [29.1621, 41.0015],
          [29.1618, 41.0024],
          [29.1612, 41.0030],
          [29.1606, 41.0027],
          [29.1600, 41.0018],
          [29.1594, 41.0009],
          [29.1591, 41.0000],
          [29.1594, 40.9991],
          [29.1600, 40.9982],
          [29.1606, 40.9985],
          [29.1612, 40.9991],
          [29.1618, 40.9994],
          [29.1600, 41.0000]
        ]]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "20gen Park (Icosagon)",
        "total_area": 52.7,
        "type": "park",
        "shape": "icosagon"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.1800, 41.0000],
          [29.1805, 40.9995],
          [29.1810, 40.9998],
          [29.1815, 41.0005],
          [29.1818, 41.0012],
          [29.1815, 41.0019],
          [29.1810, 41.0022],
          [29.1805, 41.0019],
          [29.1800, 41.0012],
          [29.1795, 41.0005],
          [29.1792, 40.9998],
          [29.1795, 40.9995],
          [29.1800, 40.9992],
          [29.1805, 40.9995],
          [29.1810, 40.9998],
          [29.1815, 41.0002],
          [29.1818, 41.0005],
          [29.1800, 41.0000]
        ]]
      }
    }
  ]
};

// Eski park verileri (nokta olarak)
export const turkeyParks = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "Gençlik Parkı",
        "city": "Ankara",
        "area": "28.5",
        "type": "park",
        "description": "Ankara'nın en büyük parkı"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [32.8597, 39.9334]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Kuğulu Park",
        "city": "Ankara",
        "area": "6.2",
        "type": "park",
        "description": "Kuğuları ile ünlü park"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [32.8500, 39.9167]
      }
    }
  ]
};

export const turkeyWaterSources = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "Atatürk Barajı",
        "type": "dam",
        "capacity": "48.7",
        "province": "Şanlıurfa"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [37.4667, 37.4833]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Keban Barajı",
        "type": "dam",
        "capacity": "31.0",
        "province": "Elazığ"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [38.8000, 38.8000]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "name": "Sapanca Gölü",
        "type": "lake",
        "area": "47",
        "province": "Sakarya"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [30.2667, 40.7167]
      }
    }
  ]
};

export const istanbulDistricts = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "name": "Beşiktaş",
        "population": 190000,
        "area": "18.2"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [29.0000, 41.0500],
          [29.0200, 41.0500],
          [29.0200, 41.0700],
          [29.0000, 41.0700],
          [29.0000, 41.0500]
        ]]
      }
    }
  ]
};
